import React, { useState, useEffect } from 'react'
import Header3d from './component/header/Header3d'
import { Outlet } from 'react-router-dom'
import SubHeader3d from './component/sub-header/SubHeader3d'
import ResultHeader3d from './component/result/ResultHeader3d'
import MainTable3d from './component/main-table/MainTable3d'
import Footer from '../2d-game/componenent/footer/Footer'

function Layout3d() {
  const [showRotateMessage, setShowRotateMessage] = useState(false)

  useEffect(() => {
    const checkScreen = () => {
      const width = window.innerWidth
      const height = window.innerHeight

      // Portrait mode on mobile
      if (width <= 425 && height > width) {
        setShowRotateMessage(true)
      } else {
        setShowRotateMessage(false)
        // If rotated to horizontal, try to enter fullscreen
        const elem = document.documentElement
        if (elem.requestFullscreen) {
          elem.requestFullscreen().catch((err) => {
            // console.log('Fullscreen request failed:', err)
          })
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
      }
    }

    checkScreen() // Check on load
    window.addEventListener('resize', checkScreen)

    return () => {
      window.removeEventListener('resize', checkScreen)
    }
  }, [])

  if (showRotateMessage) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          textAlign: 'center',
          backgroundColor: '#000',
          color: '#fff',
          fontSize: '20px',
          padding: '20px',
        }}
      >
        Please rotate your device horizontally to view this page.
      </div>
    )
  }

  return (
    <>
      <table width="100%">
        <tbody>
          <tr>
            <td height="10%" colSpan="2" align="left" valign="top">
              <ResultHeader3d />
            </td>
          </tr>
          <tr>
            <td>
              <SubHeader3d />
            </td>
          </tr>
          <tr>
            <td>
              <MainTable3d />
            </td>
          </tr>
        </tbody>
      </table>
      {/* <Footer /> */}
      <Outlet />
    </>
  )
}

export default Layout3d
